import { Drawer, Grid } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { FormControlsArrowKeysFix } from "~Components/form/formControlsArrowKeysFix"
import { onCloseDrawer } from "~Features/pages/purchaseOrders/drawer/drawer.utils"
import { AuthzService } from "~Shared/services"
import { PurchaseOrderForm } from "../components/PurchaseOrderForm"
import { useDrawerFocus } from "../hooks/useDrawerFocus.hook"
import { type PurchaseOrder } from "../types/PurchaseOrder.interfaces"

const { useBreakpoint } = Grid

interface PurchaseOrderDrawerProps {
    open: boolean
    onClose: () => void
    editMode: boolean
    purchaseOrder?: PurchaseOrder
}

export const PurchaseOrderDrawer = ({ open, onClose, editMode, purchaseOrder }: PurchaseOrderDrawerProps) => {
    const { t } = useTranslation()
    const screens = useBreakpoint()

    const { focusRef, afterOpenChange } = useDrawerFocus(open)

    const isUserAllowedToUpdatePurchaseOrder = purchaseOrder ? AuthzService.isLoggedInUserAllowedToUpdatePurchaseOrder(purchaseOrder) : false

    // Check if the current user can edit this purchase order
    const editDisabled = editMode && !isUserAllowedToUpdatePurchaseOrder

    return (
        <FormControlsArrowKeysFix>
            <Drawer
                open={open}
                title={<span>{editMode ? t("purchaseOrders:drawer.editPurchaseOrder") : t("purchaseOrders:drawer.newPurchaseOrder")}</span>}
                footer={undefined}
                destroyOnClose={true}
                placement="right"
                width={screens.xxl ? "1500px" : "800px"}
                closable={true}
                keyboard={true}
                data-testid="finway:purchaseOrder:drawer"
                onClose={onCloseDrawer(onClose)}
                afterOpenChange={afterOpenChange}
            >
                {open && <PurchaseOrderForm focusCatcher={focusRef} purchaseOrder={purchaseOrder} editMode={editMode} onCancel={onClose} disabled={editDisabled} />}
            </Drawer>
        </FormControlsArrowKeysFix>
    )
}
